import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';

@DialogFactory
@Component({
  mixins: [style],
})
export default class OtherApp extends IPSDialog {
  $refs: {
    form: ElForm;
  };

  linkAppInfo: { appName?: string; appId?: string; pagePath?: string } = {
    appName: '',
    appId: '',
    pagePath: '',
  };

  rules = {
    appName: [{ required: true, message: '', trigger: 'blur' }],
    appId: [{ required: true, message: '', trigger: 'blur' }],
    pagePath: [{ required: true, message: '', trigger: 'blur' }],
  };

  width = '600px';

  title = '跳转路径';

  confirmloading = false;

  beforeConfirm(resp = {}, cb) {
    this.$refs.form.validate((result) => {
      if (result) {
        this.$emit('result', this.linkAppInfo);
        this.$emit('hidden');
      } else {
        this.confirmloading = false;
      }
    });
  }

  renderContent(h) {
    return (
      <div class="link-other-app">
        <el-form props={{ model: this.linkAppInfo }} show-message={false} label-width="120px" label-position="left" rules={this.rules} ref="form">
          <el-form-item prop="appName" label="小程序名称">
            <el-input v-model={this.linkAppInfo.appName}></el-input>
          </el-form-item>
          <el-form-item prop="appId" label="小程序APPID">
            <el-input v-model={this.linkAppInfo.appId}></el-input>
          </el-form-item>
          <el-form-item prop="pagePath" label="页面跳转路径">
            <el-input v-model={this.linkAppInfo.pagePath}></el-input>
          </el-form-item>
        </el-form>
      </div>
    );
  }
}
